<template>
  <div class="delRecord">
    <!-- 选择子目弹框 -->
    <el-dialog
      title="删除记录"
      :visible.sync="delShow"
      width="800px"
      height="460px"
      :close-on-click-modal="false"
    >
     
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        size="mini"
        style="width: 100%"
        height="440px"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumnDatas"
          :key="index"
          :prop="item.class"
          :label="item.labelName"
          :sortable="item.sortEnable"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-footer style="height: 40px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="totalCount"
        ></el-pagination>
      </el-footer>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="delShow = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  delFileRecord,
} from "@/services/allContractServices";
export default {
  name: "delRecord",
  data() {
    return {
      delShow:false,
      itemId:0,
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      tableColumnDatas: [
        { class: "accountName", labelName: "用户账号", sortEnable: false },
        { class: "userName", labelName: "员工姓名", sortEnable: false },
        { class: "createTime", labelName: "删除时间", sortEnable: false },
        { class: "itemName", labelName: "文件", sortEnable: false }
      ],
    };
  },
  // mounted() {
  //   this.initList();
  // },

  methods: {
    showDialog(id){
      this.itemId=id
      this.delShow=true;
      this.pageIndex = 1;
      this.pageSize=10;
      this.initList();

    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.pageSize = rows;
      this.pageIndex = 1;
      //  this.selectsubItems.length=0;
      this.initList();
    },
    initList() {     
      let param = {
        projectId: this.itemId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      //删除记录接口
      delFileRecord(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.tableData=res.data;
            this.totalCount=res.total;
          } else {
            this.$alert(res.msg, "错误", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "错误", {
            confirmButtonText: "确定",
          });
        });
    
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.el-dialog__footer {
    padding: 0px 20px 20px;
   
}
</style>

